/* ==========================================================================
   TC Zenith — helpers vanilla (sem bibliotecas novas)
   Componentes: tabs, setas de carrossel scroll-snap, quick view (fetch/modal),
   add to cart inline do card, formatação de dinheiro, cart drawer 2 estados
   (ADICIONADO!/SEU CARRINHO) + enhancements AJAX da página /cart e coleção
   (densidade do grid, sort por navegação, drawer de filtros).
   Tudo opera apenas sobre elementos com atributos/classes tc-*.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Util: formatação de dinheiro
     Usa Shopify.formatMoney/geckoShopify.formatMoney se existirem;
     senão, fallback próprio baseado em t_moneyFormat (shop.money_format).
     ------------------------------------------------------------------ */
  function formatMoney(cents) {
    var format = (typeof window.t_moneyFormat === 'string' && window.t_moneyFormat) || 'R$ {{amount_with_comma_separator}}';
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format);
      }
      if (window.geckoShopify && typeof window.geckoShopify.formatMoney === 'function') {
        return window.geckoShopify.formatMoney(cents, format);
      }
    } catch (err) { /* usa fallback abaixo */ }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);

    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) { return '0'; }
      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }
    return match ? format.replace(placeholderRegex, value) : value;
  }

  /* ------------------------------------------------------------------
     Util: atualiza o contador da sacola do header existente.
     Preferência: pipeline do próprio tema (geckoShopify.onCartUpdate,
     que atualiza .jsccount, itens e totais do mini-cart via /cart?view=js).
     Fallback: /cart.js -> textContent de .jsccount.
     ------------------------------------------------------------------ */
  function updateCartBadge(productId) {
    try {
      if (window.geckoShopify && typeof window.geckoShopify.onCartUpdate === 'function') {
        window.geckoShopify.onCartUpdate(1, 1, productId);
        return;
      }
    } catch (err) { /* cai no fallback */ }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('.jsccount');
        for (var i = 0; i < badges.length; i++) {
          badges[i].textContent = cart.item_count;
        }
      })
      .catch(function () { /* silencioso: badge é enhancement */ });
  }

  /* ------------------------------------------------------------------
     Util: abre o mini-cart existente do tema.
     O tema abre #nt_cart_canvas por clique delegado em
     .push_side[data-id="#nt_cart_canvas"] (nt_theme.js/sidePopup).
     ------------------------------------------------------------------ */
  function openThemeMiniCart() {
    var canvas = document.getElementById('nt_cart_canvas');
    if (!canvas) { return false; }
    var trigger = document.querySelector('.push_side[data-id="#nt_cart_canvas"]');
    if (!trigger) { return false; }
    try {
      trigger.click();
      return true;
    } catch (err) {
      return false;
    }
  }

  /* ------------------------------------------------------------------
     Util: POST /cart/add.js
     ------------------------------------------------------------------ */
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || (data && data.status && data.status !== 200)) {
          var message = (data && (data.description || data.message)) || 'Não foi possível adicionar à sacola.';
          var error = new Error(message);
          error.cartError = true;
          throw error;
        }
        return data;
      });
    });
  }

  /* Feedback padrão pós-add: botão vira "ADICIONADO ✓" ~2s e badge
     atualizado (a abertura do drawer/mini-cart fica com openAfterAdd). */
  function afterAddFeedback(button, productId) {
    var original = button.dataset.tcLabel || button.textContent;
    button.dataset.tcLabel = original;
    button.textContent = 'ADICIONADO ✓';
    button.setAttribute('aria-disabled', 'true');
    updateCartBadge(productId);
    window.setTimeout(function () {
      button.textContent = original;
      button.removeAttribute('aria-disabled');
    }, 2000);
  }

  /* ------------------------------------------------------------------
     Tabs — [data-tc-tabs] > [data-tc-tab][aria-controls] + [data-tc-panel]
     Troca sem reload: painéis já renderizados, alternância por hidden.
     ------------------------------------------------------------------ */
  function initTabs(scope) {
    var groups = (scope || document).querySelectorAll('[data-tc-tabs]');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.dataset.tcTabsReady) { return; }
      group.dataset.tcTabsReady = '1';
      group.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-tc-tab]');
        if (!tab || !group.contains(tab)) { return; }
        event.preventDefault();
        var tabs = group.querySelectorAll('[data-tc-tab]');
        Array.prototype.forEach.call(tabs, function (other) {
          var selected = other === tab;
          other.setAttribute('aria-selected', selected ? 'true' : 'false');
          other.classList.toggle('is-active', selected);
          var panel = document.getElementById(other.getAttribute('aria-controls') || '');
          if (panel) { panel.hidden = !selected; }
        });
        var carousel = group.closest('[data-tc-carousel]') || group.parentElement;
        if (carousel) { refreshCarousel(carousel); }
      });
    });
  }

  /* ------------------------------------------------------------------
     Carrossel scroll-snap — [data-tc-carousel] com 1+ [data-tc-track]
     e botões [data-tc-prev]/[data-tc-next]. A track ativa é a visível.
     ------------------------------------------------------------------ */
  function activeTrack(carousel) {
    var tracks = carousel.querySelectorAll('[data-tc-track]');
    for (var i = 0; i < tracks.length; i++) {
      if (!tracks[i].hidden && tracks[i].offsetParent !== null) { return tracks[i]; }
    }
    return tracks[0] || null;
  }

  function refreshCarousel(carousel) {
    var track = activeTrack(carousel);
    if (!track) { return; }
    var prev = carousel.querySelector('[data-tc-prev]');
    var next = carousel.querySelector('[data-tc-next]');
    if (prev && next) {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
      var hasOverflow = track.scrollWidth > track.clientWidth + 4;
      prev.style.display = hasOverflow ? '' : 'none';
      next.style.display = hasOverflow ? '' : 'none';
    }
    /* Dots opcionais — [data-tc-dots] com botões [data-tc-dot="index"] */
    var dots = carousel.querySelectorAll('[data-tc-dot]');
    if (dots.length) {
      var current = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      Array.prototype.forEach.call(dots, function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }
  }

  function initCarousels(scope) {
    var carousels = (scope || document).querySelectorAll('[data-tc-carousel]');
    Array.prototype.forEach.call(carousels, function (carousel) {
      if (carousel.dataset.tcCarouselReady) { return; }
      carousel.dataset.tcCarouselReady = '1';

      carousel.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-tc-dot]');
        if (dot && carousel.contains(dot)) {
          var dotTrack = activeTrack(carousel);
          if (!dotTrack) { return; }
          var index = parseInt(dot.dataset.tcDot, 10) || 0;
          dotTrack.scrollTo({ left: index * dotTrack.clientWidth, behavior: 'smooth' });
          return;
        }
        var prev = event.target.closest('[data-tc-prev]');
        var next = event.target.closest('[data-tc-next]');
        if ((!prev && !next) || !carousel.contains(prev || next)) { return; }
        var track = activeTrack(carousel);
        if (!track) { return; }
        var amount = track.clientWidth;
        track.scrollBy({ left: prev ? -amount : amount, behavior: 'smooth' });
      });

      var tracks = carousel.querySelectorAll('[data-tc-track]');
      Array.prototype.forEach.call(tracks, function (track) {
        var pending = null;
        track.addEventListener('scroll', function () {
          if (pending) { window.cancelAnimationFrame(pending); }
          pending = window.requestAnimationFrame(function () { refreshCarousel(carousel); });
        }, { passive: true });
      });

      window.addEventListener('resize', function () { refreshCarousel(carousel); });
      refreshCarousel(carousel);
    });
  }

  /* ------------------------------------------------------------------
     Showcase editorial — [data-tc-showcase] com linhas
     [data-tc-showcase-trigger][data-tc-index] e imagens empilhadas
     [data-tc-showcase-img]. Hover/foco na linha ativa a imagem
     correspondente (sem JS, a primeira fica visível via is-active
     renderizada no servidor).
     ------------------------------------------------------------------ */
  function initShowcase(scope) {
    var roots = (scope || document).querySelectorAll('[data-tc-showcase]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.tcShowcaseReady) { return; }
      root.dataset.tcShowcaseReady = '1';
      var triggers = root.querySelectorAll('[data-tc-showcase-trigger]');
      var images = root.querySelectorAll('[data-tc-showcase-img]');
      if (!triggers.length || !images.length) { return; }

      function activate(index) {
        Array.prototype.forEach.call(triggers, function (trigger) {
          var i = parseInt(trigger.dataset.tcIndex, 10) || 0;
          trigger.classList.toggle('is-active', i === index);
        });
        Array.prototype.forEach.call(images, function (image, i) {
          image.classList.toggle('is-active', i === index);
        });
      }

      Array.prototype.forEach.call(triggers, function (trigger) {
        var index = parseInt(trigger.dataset.tcIndex, 10) || 0;
        trigger.addEventListener('mouseenter', function () { activate(index); });
        trigger.addEventListener('focus', function () { activate(index); });
      });
    });
  }

  /* ------------------------------------------------------------------
     Numeração rápida do card (desktop hover) — [data-tc-qadd]
     Clicar no número adiciona a variante direto e abre o drawer.
     ------------------------------------------------------------------ */
  function initCardAdd() {
    document.addEventListener('click', function (event) {
      var size = event.target.closest('[data-tc-qadd]');
      if (!size) { return; }
      event.preventDefault();
      if (size.disabled || size.classList.contains('is-unavailable') || size.classList.contains('is-loading')) { return; }
      var variantId = size.dataset.tcVariantId;
      if (!variantId) { return; }
      size.classList.add('is-loading');
      addToCart(variantId, 1)
        .then(function (data) {
          size.classList.remove('is-loading');
          size.classList.add('is-added');
          window.setTimeout(function () { size.classList.remove('is-added'); }, 1200);
          openAfterAdd(data);
        })
        .catch(function () {
          size.classList.remove('is-loading');
          size.classList.add('is-unavailable');
          window.setTimeout(function () { size.classList.remove('is-unavailable'); }, 2000);
        });
    });
  }

  /* ------------------------------------------------------------------
     Quick view — modal com fetch sob demanda (?view=tc_qv)
     Shell: snippets/tc-quick-view.liquid (.tc-qv). Focus trap, Esc,
     aria-modal, retorno de foco.
     ------------------------------------------------------------------ */
  var qv = {
    modal: null,
    body: null,
    dialog: null,
    lastFocus: null,
    cache: {},
    keydownBound: null
  };

  function qvModal() {
    if (qv.modal && document.body.contains(qv.modal)) { return qv.modal; }
    var all = document.querySelectorAll('.tc-qv');
    if (!all.length) { return null; }
    /* dedupe: mantém o primeiro shell, remove extras renderizados por outras seções */
    for (var i = 1; i < all.length; i++) {
      if (all[i].parentNode) { all[i].parentNode.removeChild(all[i]); }
    }
    qv.modal = all[0];
    qv.body = qv.modal.querySelector('.tc-qv__body');
    qv.dialog = qv.modal.querySelector('.tc-qv__dialog');
    /* move para o fim do body para escapar de contexts de stacking das seções */
    document.body.appendChild(qv.modal);

    qv.modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-tc-qv-close]')) {
        event.preventDefault();
        qvClose();
      }
    });
    return qv.modal;
  }

  function qvFocusables() {
    if (!qv.modal) { return []; }
    var nodes = qv.modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function qvKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      qvClose();
      return;
    }
    if (event.key !== 'Tab') { return; }
    var focusables = qvFocusables();
    if (!focusables.length) { return; }
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && (document.activeElement === first || !qv.modal.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function qvOpen(url, trigger) {
    var modal = qvModal();
    if (!modal) {
      window.location.href = url;
      return;
    }
    qv.lastFocus = trigger || document.activeElement;
    modal.classList.add('is-open');
    document.documentElement.classList.add('tc-scroll-lock');
    qv.keydownBound = qvKeydown;
    document.addEventListener('keydown', qv.keydownBound);

    var closeBtn = modal.querySelector('.tc-qv__close');
    if (closeBtn) { closeBtn.focus(); }

    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=tc_qv';
    if (qv.cache[fetchUrl]) {
      qvRender(qv.cache[fetchUrl]);
      return;
    }
    modal.classList.add('is-loading');
    qv.body.innerHTML = '';
    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) { throw new Error('HTTP ' + res.status); }
        return res.text();
      })
      .then(function (html) {
        qv.cache[fetchUrl] = html;
        qvRender(html);
      })
      .catch(function () {
        qvClose();
        window.location.href = url;
      });
  }

  function qvRender(html) {
    qv.modal.classList.remove('is-loading');
    qv.body.innerHTML = html;
    qvInitProduct(qv.body);
  }

  function qvClose() {
    if (!qv.modal || !qv.modal.classList.contains('is-open')) { return; }
    qv.modal.classList.remove('is-open', 'is-loading');
    document.documentElement.classList.remove('tc-scroll-lock');
    if (qv.keydownBound) {
      document.removeEventListener('keydown', qv.keydownBound);
      qv.keydownBound = null;
    }
    if (qv.lastFocus && typeof qv.lastFocus.focus === 'function' && document.body.contains(qv.lastFocus)) {
      qv.lastFocus.focus();
    }
    qv.lastFocus = null;
  }

  /* Inicializa o fragmento retornado por templates/product.tc_qv.liquid */
  function qvInitProduct(root) {
    var product = root.querySelector('[data-tc-qv-product]');
    if (!product) { return; }

    /* Galeria: scroll-snap + setas + contador 1/N */
    var track = product.querySelector('[data-tc-qv-track]');
    var counter = product.querySelector('[data-tc-qv-counter]');
    if (track) {
      var slides = track.querySelectorAll('.tc-qv-product__slide');
      var setCounter = function () {
        if (!counter || !slides.length) { return; }
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) + 1;
        index = Math.min(Math.max(index, 1), slides.length);
        counter.textContent = index + '/' + slides.length;
      };
      var rafPending = null;
      track.addEventListener('scroll', function () {
        if (rafPending) { window.cancelAnimationFrame(rafPending); }
        rafPending = window.requestAnimationFrame(setCounter);
      }, { passive: true });
      setCounter();

      product.addEventListener('click', function (event) {
        var prev = event.target.closest('[data-tc-qv-prev]');
        var next = event.target.closest('[data-tc-qv-next]');
        if (!prev && !next) { return; }
        event.preventDefault();
        track.scrollBy({ left: prev ? -track.clientWidth : track.clientWidth, behavior: 'smooth' });
      });
    }

    /* Variantes */
    var dataEl = product.querySelector('[data-tc-variants]');
    var variants = [];
    try {
      variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    } catch (err) { variants = []; }

    var form = product.querySelector('[data-tc-qv-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var addBtn = form ? form.querySelector('[data-tc-qv-add]') : null;
    var priceEl = product.querySelector('[data-tc-qv-price]');
    var compareEl = product.querySelector('[data-tc-qv-compare]');
    var installmentsEl = product.querySelector('[data-tc-qv-installments]');
    var errorEl = product.querySelector('[data-tc-qv-error]');
    var installmentsCount = parseInt((form && form.dataset.tcInstallments) || '6', 10) || 6;
    var optionRows = product.querySelectorAll('[data-tc-option-index]');

    function selectedValues() {
      var values = [];
      Array.prototype.forEach.call(optionRows, function (row) {
        var idx = parseInt(row.dataset.tcOptionIndex, 10);
        var selected = row.querySelector('.tc-pill.is-selected');
        values[idx] = selected ? selected.dataset.tcValue : null;
      });
      return values;
    }

    function matchVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] !== null && variants[i].options[j] !== values[j]) { ok = false; break; }
        }
        if (ok) { return variants[i]; }
      }
      return null;
    }

    function valueHasAvailability(optionIndex, value, values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.available) { continue; }
        if (v.options[optionIndex] !== value) { continue; }
        var ok = true;
        for (var j = 0; j < values.length; j++) {
          if (j === optionIndex || values[j] === null) { continue; }
          if (v.options[j] !== values[j]) { ok = false; break; }
        }
        if (ok) { return true; }
      }
      return false;
    }

    function refreshState() {
      var values = selectedValues();

      /* esmaece pills sem combinação disponível */
      Array.prototype.forEach.call(optionRows, function (row) {
        var idx = parseInt(row.dataset.tcOptionIndex, 10);
        var pills = row.querySelectorAll('.tc-pill');
        Array.prototype.forEach.call(pills, function (pill) {
          var has = valueHasAvailability(idx, pill.dataset.tcValue, values);
          pill.classList.toggle('is-unavailable', !has);
          pill.setAttribute('aria-disabled', has ? 'false' : 'true');
        });
      });

      var variant = matchVariant(values);
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'INDISPONÍVEL';
        }
        return;
      }
      if (idInput) { idInput.value = variant.id; }
      if (priceEl) { priceEl.textContent = formatMoney(variant.price); }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (installmentsEl) {
        installmentsEl.innerHTML = 'ou <span class="tc-parcela-hl">' + installmentsCount + 'x de ' + formatMoney(Math.round(variant.price / installmentsCount)) + '</span> sem juros';
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? (addBtn.dataset.tcLabel || 'ADICIONAR À SACOLA') : 'INDISPONÍVEL';
      }
    }

    product.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-tc-option-index] .tc-pill');
      if (!pill) { return; }
      event.preventDefault();
      if (pill.classList.contains('is-unavailable')) { return; }
      var row = pill.closest('[data-tc-option-index]');
      var pills = row.querySelectorAll('.tc-pill');
      Array.prototype.forEach.call(pills, function (other) {
        other.classList.toggle('is-selected', other === pill);
        other.setAttribute('aria-pressed', other === pill ? 'true' : 'false');
      });
      if (errorEl) { errorEl.classList.remove('is-visible'); }
      refreshState();
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!idInput || !idInput.value || !addBtn || addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') { return; }
        if (errorEl) { errorEl.classList.remove('is-visible'); }
        addBtn.dataset.tcLabel = addBtn.dataset.tcLabel || addBtn.textContent;
        addToCart(idInput.value, 1)
          .then(function (data) {
            var productId = form.dataset.tcProductId || null;
            afterAddFeedback(addBtn, productId);
            /* fecha o modal e abre o drawer novo (ADICIONADO!);
               fallback: mini-cart antigo do tema */
            window.setTimeout(function () {
              qvClose();
              openAfterAdd(data);
            }, 1200);
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = (err && err.cartError && err.message) || 'Não foi possível adicionar à sacola. Tente novamente.';
              errorEl.classList.add('is-visible');
            }
          });
      });
    }

    refreshState();
  }

  function initQuickView() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-tc-qv]');
      if (!trigger) { return; }
      var url = trigger.getAttribute('data-tc-qv');
      if (!url) { return; }
      event.preventDefault();
      qvOpen(url, trigger);
    });
  }

  /* ------------------------------------------------------------------
     Util: focus trap genérico (drawer do menu e overlay de busca).
     Filtra elementos invisíveis (painéis com visibility:hidden).
     ------------------------------------------------------------------ */
  function trapTab(root, event) {
    var nodes = root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var focusables = Array.prototype.filter.call(nodes, function (el) {
      if (el.getClientRects().length === 0 && el !== document.activeElement) { return false; }
      return window.getComputedStyle(el).visibility !== 'hidden';
    });
    if (!focusables.length) { return; }
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ------------------------------------------------------------------
     Header — mega menu desktop (§3.2)
     [data-tc-header] > [data-tc-mega-item] com [data-tc-mega-link] +
     [data-tc-mega-panel]. Abre no hover/foco, fecha em mouseleave/
     focusout/Esc/clique fora. aria-expanded no link.
     ------------------------------------------------------------------ */
  function initHeaderMega(scope) {
    var headers = (scope || document).querySelectorAll('[data-tc-header]');
    Array.prototype.forEach.call(headers, function (header) {
      if (header.dataset.tcMegaReady) { return; }
      header.dataset.tcMegaReady = '1';
      var items = header.querySelectorAll('[data-tc-mega-item]');
      if (!items.length) { return; }

      function closeItem(item) {
        item.classList.remove('is-open');
        var link = item.querySelector('[data-tc-mega-link]');
        if (link) { link.setAttribute('aria-expanded', 'false'); }
      }

      function closeAll() {
        Array.prototype.forEach.call(items, closeItem);
      }

      Array.prototype.forEach.call(items, function (item) {
        var link = item.querySelector('[data-tc-mega-link]');
        var closeTimer = null;

        function cancelClose() {
          if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
        }

        function open() {
          cancelClose();
          closeAll();
          item.classList.add('is-open');
          if (link) { link.setAttribute('aria-expanded', 'true'); }
        }

        /* Fecha com atraso: dá tempo de cruzar o espaço entre o item e o painel */
        function scheduleClose() {
          cancelClose();
          closeTimer = window.setTimeout(function () { closeItem(item); closeTimer = null; }, 220);
        }

        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', scheduleClose);
        item.addEventListener('focusin', open);
        item.addEventListener('focusout', function (event) {
          if (!item.contains(event.relatedTarget)) { closeItem(item); }
        });
      });

      header.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' && event.key !== 'Esc') { return; }
        var openItem = header.querySelector('[data-tc-mega-item].is-open');
        if (!openItem) { return; }
        event.preventDefault();
        var link = openItem.querySelector('[data-tc-mega-link]');
        closeItem(openItem);
        if (link) { link.focus(); }
      });

      document.addEventListener('click', function (event) {
        if (!header.contains(event.target)) { closeAll(); }
      });
    });
  }

  /* ------------------------------------------------------------------
     Menu drawer mobile (§3.1) — [data-tc-drawer]
     Aberto por [data-tc-drawer-open] (hambúrguer), fechado por
     [data-tc-drawer-close]/Esc. Painéis de 2º nível [data-tc-sub]
     abertos por [data-tc-sub-open="id"], voltam por [data-tc-sub-back].
     Trava scroll, focus trap, aria-expanded no hambúrguer.
     ------------------------------------------------------------------ */
  var tcDrawer = { root: null, lastFocus: null, keydownBound: null };

  function drawerSetExpanded(value) {
    var triggers = document.querySelectorAll('[data-tc-drawer-open]');
    Array.prototype.forEach.call(triggers, function (trigger) {
      trigger.setAttribute('aria-expanded', value ? 'true' : 'false');
    });
  }

  function drawerKeydown(event) {
    if (!tcDrawer.root) { return; }
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key === 'Tab') { trapTab(tcDrawer.root, event); }
  }

  function openDrawer(trigger) {
    var root = document.querySelector('[data-tc-drawer]');
    if (!root) { return; }
    tcDrawer.root = root;
    tcDrawer.lastFocus = trigger || document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tc-scroll-lock');
    drawerSetExpanded(true);
    tcDrawer.keydownBound = drawerKeydown;
    document.addEventListener('keydown', tcDrawer.keydownBound);
    var closeBtn = root.querySelector('[data-tc-drawer-close]');
    if (closeBtn) { closeBtn.focus(); }
  }

  function closeDrawer(skipFocus) {
    var root = tcDrawer.root || document.querySelector('[data-tc-drawer]');
    if (!root || !root.classList.contains('is-open')) { return; }
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    var panels = root.querySelectorAll('[data-tc-sub].is-open');
    Array.prototype.forEach.call(panels, function (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
    var subBtns = root.querySelectorAll('[data-tc-sub-open]');
    Array.prototype.forEach.call(subBtns, function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
    document.documentElement.classList.remove('tc-scroll-lock');
    drawerSetExpanded(false);
    if (tcDrawer.keydownBound) {
      document.removeEventListener('keydown', tcDrawer.keydownBound);
      tcDrawer.keydownBound = null;
    }
    if (!skipFocus && tcDrawer.lastFocus && typeof tcDrawer.lastFocus.focus === 'function' && document.body.contains(tcDrawer.lastFocus)) {
      tcDrawer.lastFocus.focus();
    }
    tcDrawer.lastFocus = null;
  }

  function openDrawerSub(btn) {
    var id = btn.getAttribute('data-tc-sub-open');
    var panel = id ? document.getElementById(id) : null;
    if (!panel) { return; }
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    var back = panel.querySelector('[data-tc-sub-back]');
    if (back) { back.focus(); }
  }

  function closeDrawerSub(backBtn) {
    var panel = backBtn.closest('[data-tc-sub]');
    if (!panel) { return; }
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    var opener = document.querySelector('[data-tc-sub-open="' + panel.id + '"]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus();
    }
  }

  /* ------------------------------------------------------------------
     Overlay de busca (§3.3) — [data-tc-search]
     Resultados COM MINIATURA via predictive search nativa
     (/search/suggest.json). Debounce ~300ms, mínimo 2 caracteres,
     tabs PRODUTOS/COLEÇÕES, estados vazio/carregando, focus trap,
     Esc, setas ↑/↓ nos resultados, aria-live no snippet.
     ------------------------------------------------------------------ */
  var tcSearch = { root: null, lastFocus: null, keydownBound: null, timer: null, controller: null, activeTab: 'products' };

  function searchEls(root) {
    return {
      input: root.querySelector('[data-tc-search-input]'),
      clear: root.querySelector('[data-tc-search-clear]'),
      tabs: root.querySelector('[data-tc-search-tabs]'),
      tabBtns: root.querySelectorAll('[data-tc-search-tab]'),
      products: root.querySelector('[data-tc-search-panel="products"]'),
      collections: root.querySelector('[data-tc-search-panel="collections"]'),
      skeleton: root.querySelector('[data-tc-search-skeleton]'),
      empty: root.querySelector('[data-tc-search-empty]'),
      promo: root.querySelector('[data-tc-search-promo]'),
      all: root.querySelector('[data-tc-search-all]')
    };
  }

  function moneyFromString(value) {
    var num = parseFloat(value);
    if (isNaN(num)) { return null; }
    return formatMoney(Math.round(num * 100));
  }

  function searchThumb(imageUrl, altText, fallbackText) {
    if (imageUrl) {
      var img = document.createElement('img');
      img.className = 'tc-search__thumb';
      img.src = imageUrl + (imageUrl.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      img.width = 60;
      img.height = 60;
      img.loading = 'lazy';
      img.alt = altText || '';
      return img;
    }
    var ph = document.createElement('span');
    ph.className = 'tc-search__thumb tc-search__thumb--ph';
    ph.setAttribute('aria-hidden', 'true');
    ph.textContent = (fallbackText || '?').charAt(0);
    return ph;
  }

  function searchResultItem(url, imageUrl, title, priceNow, priceWas) {
    var li = document.createElement('li');
    li.className = 'tc-search__item';
    var a = document.createElement('a');
    a.href = url;
    a.appendChild(searchThumb(imageUrl, title, title));
    var info = document.createElement('span');
    info.className = 'tc-search__item-info';
    var titleEl = document.createElement('span');
    titleEl.className = 'tc-search__item-title';
    titleEl.textContent = title;
    info.appendChild(titleEl);
    if (priceNow) {
      var priceRow = document.createElement('span');
      priceRow.className = 'tc-search__item-price';
      var now = document.createElement('span');
      now.className = 'tc-search__price-now';
      now.textContent = priceNow;
      priceRow.appendChild(now);
      if (priceWas) {
        var was = document.createElement('s');
        was.className = 'tc-search__price-was';
        was.textContent = priceWas;
        priceRow.appendChild(was);
      }
      info.appendChild(priceRow);
    }
    a.appendChild(info);
    li.appendChild(a);
    return li;
  }

  function setSearchTab(btn) {
    var root = btn.closest('[data-tc-search]');
    if (!root) { return; }
    var els = searchEls(root);
    var name = btn.getAttribute('data-tc-search-tab') || 'products';
    tcSearch.activeTab = name;
    Array.prototype.forEach.call(els.tabBtns, function (other) {
      var active = other === btn;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (els.products) { els.products.hidden = name !== 'products'; }
    if (els.collections) { els.collections.hidden = name !== 'collections'; }
  }

  function activateSearchTab(root, name) {
    var btn = root.querySelector('[data-tc-search-tab="' + name + '"]');
    if (btn) { setSearchTab(btn); }
  }

  function searchRenderIdle(root) {
    var els = searchEls(root);
    if (tcSearch.timer) { window.clearTimeout(tcSearch.timer); tcSearch.timer = null; }
    if (tcSearch.controller) { try { tcSearch.controller.abort(); } catch (err) { /* noop */ } tcSearch.controller = null; }
    if (els.products) { els.products.innerHTML = ''; els.products.hidden = false; }
    if (els.collections) { els.collections.innerHTML = ''; els.collections.hidden = true; }
    if (els.tabs) { els.tabs.hidden = true; }
    if (els.skeleton) { els.skeleton.hidden = true; }
    if (els.empty) { els.empty.hidden = true; }
    if (els.all) { els.all.hidden = true; }
    if (els.promo) { els.promo.hidden = false; }
    if (els.clear) { els.clear.hidden = !(els.input && els.input.value.length); }
    tcSearch.activeTab = 'products';
    var firstTab = root.querySelector('[data-tc-search-tab="products"]');
    if (firstTab) {
      Array.prototype.forEach.call(els.tabBtns, function (other) {
        var active = other === firstTab;
        other.classList.toggle('is-active', active);
        other.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
  }

  function searchRenderResults(root, term, data) {
    var els = searchEls(root);
    var results = (data && data.resources && data.resources.results) || {};
    var products = results.products || [];
    var collections = results.collections || [];

    if (els.skeleton) { els.skeleton.hidden = true; }
    if (els.promo) { els.promo.hidden = true; }

    if (els.products) {
      els.products.innerHTML = '';
      products.forEach(function (p) {
        var priceNow = moneyFromString(p.price != null ? p.price : p.price_min);
        var priceWas = null;
        var compare = parseFloat(p.compare_at_price_max);
        var current = parseFloat(p.price != null ? p.price : p.price_min);
        if (!isNaN(compare) && !isNaN(current) && compare > current) {
          priceWas = moneyFromString(p.compare_at_price_max);
        }
        var imageUrl = (p.featured_image && p.featured_image.url) || p.image || null;
        els.products.appendChild(searchResultItem(p.url, imageUrl, p.title, priceNow, priceWas));
      });
    }

    if (els.collections) {
      els.collections.innerHTML = '';
      collections.forEach(function (c) {
        var imageUrl = (c.featured_image && c.featured_image.url) || null;
        els.collections.appendChild(searchResultItem(c.url, imageUrl, c.title, null, null));
      });
    }

    var total = products.length + collections.length;
    if (els.empty) {
      if (total === 0) {
        els.empty.textContent = 'Nenhum resultado para "' + term + '"';
        els.empty.hidden = false;
      } else {
        els.empty.hidden = true;
      }
    }
    if (els.tabs) { els.tabs.hidden = total === 0; }
    if (els.all) {
      els.all.href = (root.getAttribute('data-search-url') || '/search') + '?q=' + encodeURIComponent(term);
      els.all.hidden = total === 0;
    }

    /* mantém a tab ativa; se ela ficou vazia e a outra tem resultado, troca */
    var active = tcSearch.activeTab;
    if (active === 'products' && products.length === 0 && collections.length > 0) { active = 'collections'; }
    if (active === 'collections' && collections.length === 0 && products.length > 0) { active = 'products'; }
    activateSearchTab(root, active);
  }

  function searchFetch(root, term) {
    var els = searchEls(root);
    if (els.skeleton) { els.skeleton.hidden = false; }
    if (els.empty) { els.empty.hidden = true; }
    if (els.promo) { els.promo.hidden = true; }
    var base = (root.getAttribute('data-search-url') || '/search') + '/suggest.json';
    var url = base + '?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=8&resources[options][fields]=title,product_type,variants.title';
    var opts = { credentials: 'same-origin' };
    if (window.AbortController) {
      if (tcSearch.controller) { try { tcSearch.controller.abort(); } catch (err) { /* noop */ } }
      tcSearch.controller = new AbortController();
      opts.signal = tcSearch.controller.signal;
    }
    fetch(url, opts)
      .then(function (res) {
        if (!res.ok) { throw new Error('HTTP ' + res.status); }
        return res.json();
      })
      .then(function (data) {
        if (!els.input || els.input.value.trim() !== term) { return; }
        searchRenderResults(root, term, data);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') { return; }
        if (els.skeleton) { els.skeleton.hidden = true; }
        if (els.empty) {
          els.empty.textContent = 'Não foi possível buscar agora. Tente novamente.';
          els.empty.hidden = false;
        }
      });
  }

  function bindSearch(root) {
    if (root.dataset.tcSearchReady) { return; }
    root.dataset.tcSearchReady = '1';
    var els = searchEls(root);
    if (!els.input) { return; }
    els.input.addEventListener('input', function () {
      var term = els.input.value.trim();
      if (els.clear) { els.clear.hidden = els.input.value.length === 0; }
      if (tcSearch.timer) { window.clearTimeout(tcSearch.timer); }
      if (term.length < 2) {
        searchRenderIdle(root);
        return;
      }
      tcSearch.timer = window.setTimeout(function () {
        searchFetch(root, term);
      }, 300);
    });
  }

  function searchKeydown(event) {
    var root = tcSearch.root;
    if (!root || !root.classList.contains('is-open')) { return; }
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeSearch();
      return;
    }
    if (event.key === 'Tab') {
      trapTab(root, event);
      return;
    }
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      var panel = root.querySelector('[data-tc-search-panel]:not([hidden])');
      if (!panel) { return; }
      var links = Array.prototype.slice.call(panel.querySelectorAll('a'));
      if (!links.length) { return; }
      event.preventDefault();
      var idx = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') {
        idx = idx + 1 >= links.length ? 0 : idx + 1;
      } else {
        idx = idx <= 0 ? links.length - 1 : idx - 1;
      }
      links[idx].focus();
    }
  }

  function openSearch(returnTo) {
    var root = document.querySelector('[data-tc-search]');
    if (!root) { return; }
    tcSearch.root = root;
    tcSearch.lastFocus = returnTo || document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tc-scroll-lock');
    bindSearch(root);
    tcSearch.keydownBound = searchKeydown;
    document.addEventListener('keydown', tcSearch.keydownBound);
    var input = root.querySelector('[data-tc-search-input]');
    if (input) {
      window.setTimeout(function () { input.focus(); }, 30);
    }
  }

  function closeSearch() {
    var root = tcSearch.root || document.querySelector('[data-tc-search]');
    if (!root || !root.classList.contains('is-open')) { return; }
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tc-scroll-lock');
    if (tcSearch.keydownBound) {
      document.removeEventListener('keydown', tcSearch.keydownBound);
      tcSearch.keydownBound = null;
    }
    var target = tcSearch.lastFocus;
    if (target && typeof target.focus === 'function' && document.body.contains(target) && target.getClientRects().length > 0) {
      target.focus();
    } else {
      var burger = document.querySelector('[data-tc-drawer-open]');
      if (burger && burger.getClientRects().length > 0) { burger.focus(); }
    }
    tcSearch.lastFocus = null;
  }

  function clearSearch(btn) {
    var root = (btn && btn.closest('[data-tc-search]')) || tcSearch.root;
    if (!root) { return; }
    var input = root.querySelector('[data-tc-search-input]');
    if (input) {
      input.value = '';
      input.focus();
    }
    searchRenderIdle(root);
  }

  /* ------------------------------------------------------------------
     Footer — acordeões <details> no mobile, colunas abertas no desktop
     [data-tc-footer-cols]. O CSS desktop esconde o chevron e desativa
     o summary (pointer-events: none).
     ------------------------------------------------------------------ */
  function initFooterCols(scope) {
    var grids = (scope || document).querySelectorAll('[data-tc-footer-cols]');
    Array.prototype.forEach.call(grids, function (grid) {
      if (grid.dataset.tcFooterReady) { return; }
      grid.dataset.tcFooterReady = '1';
      var mq = window.matchMedia('(min-width: 750px)');

      function apply() {
        var details = grid.querySelectorAll('details.tc-footer__col');
        Array.prototype.forEach.call(details, function (d) {
          if (mq.matches) {
            d.setAttribute('open', '');
          } else {
            d.removeAttribute('open');
          }
        });
      }

      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', apply);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(apply);
      }
      apply();
    });
  }

  /* ------------------------------------------------------------------
     Cliques delegados dos globais (drawer + busca) — bind único.
     ------------------------------------------------------------------ */
  var tcGlobalNavBound = false;

  function initGlobalNav() {
    if (tcGlobalNavBound) { return; }
    tcGlobalNavBound = true;
    document.addEventListener('click', function (event) {
      var t = event.target.closest('[data-tc-drawer-open]');
      if (t) {
        event.preventDefault();
        openDrawer(t);
        return;
      }
      t = event.target.closest('[data-tc-drawer-close]');
      if (t) {
        event.preventDefault();
        closeDrawer();
        return;
      }
      t = event.target.closest('[data-tc-sub-open]');
      if (t) {
        event.preventDefault();
        openDrawerSub(t);
        return;
      }
      t = event.target.closest('[data-tc-sub-back]');
      if (t) {
        event.preventDefault();
        closeDrawerSub(t);
        return;
      }
      t = event.target.closest('[data-tc-search-open]');
      if (t) {
        event.preventDefault();
        var returnTo = t;
        if (t.closest('[data-tc-drawer]')) {
          returnTo = tcDrawer.lastFocus || t;
          closeDrawer(true);
        }
        openSearch(returnTo);
        return;
      }
      t = event.target.closest('[data-tc-search-close]');
      if (t) {
        event.preventDefault();
        closeSearch();
        return;
      }
      t = event.target.closest('[data-tc-search-clear]');
      if (t) {
        event.preventDefault();
        clearSearch(t);
        return;
      }
      t = event.target.closest('[data-tc-search-tab]');
      if (t) {
        event.preventDefault();
        setSearchTab(t);
      }
    });
  }

  /* ------------------------------------------------------------------
     Carrinho TC Zenith — drawer 2 estados + enhancements da página /cart
     Estado via GET /cart.js; stepper/remover via POST /cart/change.js
     (otimista com rollback); renderização client-side com createElement
     (dados sempre via textContent; innerHTML só para SVGs estáticos).
     Markup dos itens espelha snippets/tc-cart-item.liquid (.tc-ci*).
     ------------------------------------------------------------------ */
  var TC_SVG_TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 7h16"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/><path d="M6 7l1 13a1.5 1.5 0 0 0 1.5 1.4h7a1.5 1.5 0 0 0 1.5-1.4l1-13"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';
  var TC_SVG_MINUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var TC_SVG_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

  var tcCart = {
    state: null,
    mode: 'cart',
    addedKey: null,
    lastFocus: null,
    keydownBound: null,
    timers: {},
    recCache: {},
    uiBound: false
  };

  function cartDrawerEl() {
    return document.querySelector('[data-tc-cartd]');
  }

  function cartPageEl() {
    return document.querySelector('[data-tc-cartp]');
  }

  function cartImageSrc(url, width) {
    if (!url) { return null; }
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* "Tamanho: 40" → "Tam: 40" (mesma regra do snippet tc-cart-item) */
  function cartOptionLabel(name) {
    if (!name) { return ''; }
    if (name.toLowerCase().indexOf('tamanho') !== -1) { return 'Tam'; }
    return name;
  }

  function cartVariantText(item) {
    if (!item.variant_title || item.variant_title === 'Default Title') { return ''; }
    var parts = [];
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (!opts[i] || opts[i].value == null || opts[i].value === '' || opts[i].value === 'Default Title') { continue; }
      parts.push(cartOptionLabel(opts[i].name) + ': ' + opts[i].value);
    }
    if (!parts.length) { return item.variant_title; }
    return parts.join(' · ');
  }

  function fillCartItemPrice(container, item) {
    container.innerHTML = '';
    if (item.original_line_price > item.final_line_price) {
      var was = document.createElement('s');
      was.className = 'tc-ci__price-was';
      was.textContent = formatMoney(item.original_line_price);
      container.appendChild(was);
    }
    var now = document.createElement('span');
    now.className = 'tc-ci__price-now';
    now.textContent = formatMoney(item.final_line_price);
    container.appendChild(now);
  }

  /* Espelha snippets/tc-cart-item.liquid — alterou lá? Atualize aqui. */
  function buildCartItem(item, context) {
    var root = document.createElement('div');
    root.className = 'tc-ci tc-ci--' + (context || 'drawer');
    root.setAttribute('data-tc-ci', '');
    root.setAttribute('data-tc-ci-key', item.key);

    var media = document.createElement('a');
    media.className = 'tc-ci__media';
    media.href = item.url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (item.image) {
      var img = document.createElement('img');
      img.className = 'tc-ci__img';
      img.src = cartImageSrc(item.image, 240);
      img.width = 96;
      img.height = 96;
      img.loading = 'lazy';
      img.alt = '';
      media.appendChild(img);
    } else {
      var ph = document.createElement('span');
      ph.className = 'tc-ci__ph';
      ph.setAttribute('aria-hidden', 'true');
      media.appendChild(ph);
    }
    root.appendChild(media);

    var body = document.createElement('div');
    body.className = 'tc-ci__body';

    var top = document.createElement('div');
    top.className = 'tc-ci__top';

    var meta = document.createElement('div');
    meta.className = 'tc-ci__meta';
    var title = document.createElement('p');
    title.className = 'tc-ci__title';
    var titleLink = document.createElement('a');
    titleLink.href = item.url;
    titleLink.textContent = item.product_title;
    title.appendChild(titleLink);
    meta.appendChild(title);

    var variantText = cartVariantText(item);
    if (variantText) {
      var variant = document.createElement('p');
      variant.className = 'tc-ci__variant';
      variant.textContent = variantText;
      meta.appendChild(variant);
    }
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      var plan = document.createElement('p');
      plan.className = 'tc-ci__plan';
      plan.textContent = item.selling_plan_allocation.selling_plan.name;
      meta.appendChild(plan);
    }
    top.appendChild(meta);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'tc-ci__remove';
    remove.setAttribute('data-tc-ci-remove', '');
    remove.setAttribute('aria-label', 'Remover ' + item.product_title);
    var removeTxt = document.createElement('span');
    removeTxt.className = 'tc-ci__remove-txt';
    removeTxt.textContent = 'Remover';
    remove.appendChild(removeTxt);
    var removeIco = document.createElement('span');
    removeIco.className = 'tc-ci__remove-ico';
    removeIco.setAttribute('aria-hidden', 'true');
    removeIco.innerHTML = TC_SVG_TRASH;
    remove.appendChild(removeIco);
    top.appendChild(remove);
    body.appendChild(top);

    var error = document.createElement('p');
    error.className = 'tc-ci__error';
    error.setAttribute('data-tc-ci-error', '');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    body.appendChild(error);

    var bottom = document.createElement('div');
    bottom.className = 'tc-ci__bottom';

    var stepper = document.createElement('div');
    stepper.className = 'tc-ci__stepper';
    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'tc-ci__step';
    minus.setAttribute('data-tc-ci-minus', '');
    minus.setAttribute('aria-label', 'Diminuir quantidade');
    minus.innerHTML = TC_SVG_MINUS;
    minus.disabled = item.quantity <= 1;
    stepper.appendChild(minus);
    var qty = document.createElement('span');
    qty.className = 'tc-ci__qty';
    qty.setAttribute('data-tc-ci-qty', '');
    qty.textContent = item.quantity;
    stepper.appendChild(qty);
    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'tc-ci__step';
    plus.setAttribute('data-tc-ci-plus', '');
    plus.setAttribute('aria-label', 'Aumentar quantidade');
    plus.innerHTML = TC_SVG_PLUS;
    stepper.appendChild(plus);
    bottom.appendChild(stepper);

    var price = document.createElement('div');
    price.className = 'tc-ci__price';
    price.setAttribute('data-tc-ci-price', '');
    fillCartItemPrice(price, item);
    bottom.appendChild(price);

    body.appendChild(bottom);
    root.appendChild(body);
    return root;
  }

  function cartSyncBadges(count) {
    var badges = document.querySelectorAll('.jsccount');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
    }
    var counters = document.querySelectorAll('[data-tc-cartd-count]');
    for (var j = 0; j < counters.length; j++) {
      counters[j].textContent = count;
    }
  }

  /* Barras de frete grátis ([data-tc-ship]) — drawer e página */
  function cartShipBarsUpdate(totalCents) {
    var bars = document.querySelectorAll('[data-tc-ship]');
    Array.prototype.forEach.call(bars, function (bar) {
      var limit = parseInt(bar.getAttribute('data-tc-ship-limit'), 10) || 0;
      var fill = bar.querySelector('[data-tc-ship-fill]');
      var msg = bar.querySelector('[data-tc-ship-msg]');
      var pct = 100;
      var text = bar.getAttribute('data-tc-ship-free-text') || '';
      if (limit > 0) {
        if (totalCents >= limit) {
          text = bar.getAttribute('data-tc-ship-reached-text') || '';
        } else {
          pct = Math.max(6, Math.round((totalCents / limit) * 100));
          text = (bar.getAttribute('data-tc-ship-missing-text') || '').replace('[valor]', formatMoney(limit - totalCents));
        }
      }
      if (fill) { fill.style.width = pct + '%'; }
      if (msg) { msg.textContent = text; }
      bar.classList.toggle('is-reached', pct === 100);
    });
  }

  /* Linhas de parcelas ([data-tc-parcelas]) — drawer e página */
  function cartParcelasUpdate(totalCents) {
    var els = document.querySelectorAll('[data-tc-parcelas]');
    Array.prototype.forEach.call(els, function (el) {
      var n = parseInt(el.getAttribute('data-tc-parcelas-n'), 10) || 6;
      el.innerHTML = 'ou <span class="tc-parcela-hl">' + n + 'x de ' + formatMoney(Math.round(totalCents / n)) + '</span> sem juros';
      el.hidden = totalCents <= 0;
    });
  }

  function cartItemError(key, message) {
    var els = document.querySelectorAll('[data-tc-ci][data-tc-ci-key="' + key + '"] [data-tc-ci-error]');
    Array.prototype.forEach.call(els, function (el) {
      el.textContent = message || '';
      el.hidden = !message;
    });
  }

  /* Mini-cards do upsell do drawer (SEM quick view) */
  function buildUpsellCard(p) {
    var a = document.createElement('a');
    a.className = 'tc-cartd__uitem';
    a.href = p.url;

    var media = document.createElement('span');
    media.className = 'tc-cartd__uitem-media';
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = cartImageSrc(p.featured_image, 400);
      img.width = 200;
      img.height = 200;
      img.loading = 'lazy';
      img.alt = '';
      media.appendChild(img);
    } else {
      var ph = document.createElement('span');
      ph.className = 'tc-cartd__uitem-ph';
      ph.setAttribute('aria-hidden', 'true');
      media.appendChild(ph);
    }

    var badges = [];
    var isNew = false;
    if (p.created_at) {
      var age = Date.now() - new Date(p.created_at).getTime();
      if (!isNaN(age) && age <= 2592000000) { isNew = true; }
    }
    if (p.tags && p.tags.join(',').toLowerCase().split(',').indexOf('novo') > -1) { isNew = true; }
    if (isNew) { badges.push(['NOVO', 'tc-badge']); }
    if (p.compare_at_price && p.compare_at_price > p.price) { badges.push(['OFERTA', 'tc-badge tc-badge--oferta']); }
    if (badges.length) {
      var badgeWrap = document.createElement('span');
      badgeWrap.className = 'tc-cartd__uitem-badges';
      for (var b = 0; b < badges.length; b++) {
        var badge = document.createElement('span');
        badge.className = badges[b][1];
        badge.textContent = badges[b][0];
        badgeWrap.appendChild(badge);
      }
      media.appendChild(badgeWrap);
    }
    a.appendChild(media);

    var title = document.createElement('span');
    title.className = 'tc-cartd__uitem-title';
    title.textContent = p.title;
    a.appendChild(title);

    var price = document.createElement('span');
    price.className = 'tc-cartd__uitem-price';
    var now = document.createElement('span');
    now.className = 'tc-cartd__uitem-now';
    now.textContent = formatMoney(p.price);
    price.appendChild(now);
    if (p.compare_at_price && p.compare_at_price > p.price) {
      var was = document.createElement('s');
      was.className = 'tc-cartd__uitem-was';
      was.textContent = formatMoney(p.compare_at_price);
      price.appendChild(was);
    }
    a.appendChild(price);
    return a;
  }

  function renderDrawerUpsell(upsell, grid, products) {
    grid.innerHTML = '';
    if (!products.length || tcCart.mode !== 'added') {
      upsell.hidden = true;
      return;
    }
    for (var i = 0; i < products.length && i < 4; i++) {
      grid.appendChild(buildUpsellCard(products[i]));
    }
    upsell.hidden = false;
  }

  function loadDrawerUpsell(upsell, productId) {
    var grid = upsell.querySelector('[data-tc-cartd-upsell-grid]');
    if (!grid || !productId) {
      upsell.hidden = true;
      return;
    }
    if (tcCart.recCache[productId]) {
      renderDrawerUpsell(upsell, grid, tcCart.recCache[productId]);
      return;
    }
    upsell.hidden = true;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) { throw new Error('HTTP ' + res.status); }
        return res.json();
      })
      .then(function (data) {
        var products = (data && data.products) || [];
        tcCart.recCache[productId] = products;
        renderDrawerUpsell(upsell, grid, products);
      })
      .catch(function () {
        upsell.hidden = true;
      });
  }

  function renderCartDrawer() {
    var root = cartDrawerEl();
    var cart = tcCart.state;
    if (!root || !cart) { return; }

    var isEmpty = cart.item_count === 0;
    var added = null;
    if (tcCart.mode === 'added') {
      if (tcCart.addedKey) {
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === tcCart.addedKey) { added = cart.items[i]; break; }
        }
        if (!added) { tcCart.mode = 'cart'; }
      } else if (cart.items.length) {
        /* sem key (fallback): /cart.js lista o item mais recente primeiro */
        added = cart.items[0];
      } else {
        tcCart.mode = 'cart';
      }
    }
    root.classList.toggle('is-mode-added', tcCart.mode === 'added');

    var titleCart = root.querySelector('[data-tc-cartd-title="cart"]');
    var titleAdded = root.querySelector('[data-tc-cartd-title="added"]');
    if (titleCart) { titleCart.hidden = tcCart.mode === 'added'; }
    if (titleAdded) { titleAdded.hidden = tcCart.mode !== 'added'; }

    var wrap = root.querySelector('[data-tc-cartd-items]');
    if (wrap) {
      wrap.innerHTML = '';
      var list = tcCart.mode === 'added' && added ? [added] : cart.items;
      for (var j = 0; j < list.length; j++) {
        wrap.appendChild(buildCartItem(list[j], 'drawer'));
      }
    }

    var empty = root.querySelector('[data-tc-cartd-empty]');
    var footer = root.querySelector('[data-tc-cartd-footer]');
    var shipWrap = root.querySelector('[data-tc-cartd-shipwrap]');
    if (empty) { empty.hidden = !isEmpty; }
    if (footer) { footer.hidden = isEmpty; }
    if (shipWrap) { shipWrap.hidden = isEmpty; }

    var upsell = root.querySelector('[data-tc-cartd-upsell]');
    if (upsell) {
      if (tcCart.mode === 'added' && added) {
        loadDrawerUpsell(upsell, added.product_id);
      } else {
        upsell.hidden = true;
      }
    }

    var subtotal = root.querySelector('[data-tc-cartd-subtotal]');
    if (subtotal) { subtotal.textContent = formatMoney(cart.total_price); }
  }

  /* Página /cart: atualiza itens SSR in-place a partir do estado */
  function renderCartPage() {
    var page = cartPageEl();
    var cart = tcCart.state;
    if (!page || !cart) { return; }

    var isEmpty = cart.item_count === 0;
    var filled = page.querySelector('[data-tc-cartp-filled]');
    var empty = page.querySelector('[data-tc-cartp-empty]');
    var ship = page.querySelector('[data-tc-cartp-ship]');
    if (filled) { filled.hidden = isEmpty; }
    if (empty) { empty.hidden = !isEmpty; }
    if (ship) { ship.hidden = isEmpty; }
    if (isEmpty) {
      var upsell = page.querySelector('[data-tc-cartp-upsell]');
      if (upsell) { upsell.hidden = true; }
    }

    var itemsWrap = page.querySelector('[data-tc-cartp-items]');
    if (itemsWrap) {
      var byKey = {};
      for (var i = 0; i < cart.items.length; i++) {
        byKey[cart.items[i].key] = cart.items[i];
      }
      var seen = {};
      var els = itemsWrap.querySelectorAll('[data-tc-ci]');
      Array.prototype.forEach.call(els, function (el) {
        var key = el.getAttribute('data-tc-ci-key');
        var line = byKey[key];
        if (!line) {
          if (el.parentNode) { el.parentNode.removeChild(el); }
          return;
        }
        seen[key] = true;
        var qtyEl = el.querySelector('[data-tc-ci-qty]');
        if (qtyEl) { qtyEl.textContent = line.quantity; }
        var minus = el.querySelector('[data-tc-ci-minus]');
        if (minus) { minus.disabled = line.quantity <= 1; }
        var priceEl = el.querySelector('[data-tc-ci-price]');
        if (priceEl) { fillCartItemPrice(priceEl, line); }
        el.classList.remove('is-busy');
      });
      for (var k = 0; k < cart.items.length; k++) {
        if (!seen[cart.items[k].key]) {
          itemsWrap.appendChild(buildCartItem(cart.items[k], 'page'));
        }
      }
    }

    var subtotal = page.querySelector('[data-tc-cartp-subtotal]');
    if (subtotal) { subtotal.textContent = formatMoney(cart.items_subtotal_price); }
    var discountRow = page.querySelector('[data-tc-cartp-discount-row]');
    if (discountRow) { discountRow.hidden = !(cart.total_discount > 0); }
    var discountVal = page.querySelector('[data-tc-cartp-discount]');
    if (discountVal && cart.total_discount > 0) { discountVal.textContent = '−' + formatMoney(cart.total_discount); }
    var total = page.querySelector('[data-tc-cartp-total]');
    if (total) { total.textContent = formatMoney(cart.total_price); }
  }

  function applyCartState(cart) {
    if (!cart) { return; }
    tcCart.state = cart;
    cartSyncBadges(cart.item_count);
    cartShipBarsUpdate(cart.total_price);
    cartParcelasUpdate(cart.total_price);
    renderCartDrawer();
    renderCartPage();
  }

  function fetchCartState() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) { throw new Error('HTTP ' + res.status); }
      return res.json();
    });
  }

  function cartRequestChange(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var message = (data && (data.description || data.message)) || 'Não foi possível atualizar a sacola.';
          var error = new Error(message);
          error.cartError = true;
          throw error;
        }
        return data;
      });
    });
  }

  /* Stepper/remover: otimista (qty na hora), debounce, rollback em erro.
     quantity 0 = remover (sem debounce). O /cart/change.js não devolve erro
     ao passar do estoque — ele limita a quantidade; detectamos e avisamos
     inline sem fechar o drawer. */
  function cartChangeQty(key, quantity) {
    cartItemError(key, '');
    var els = document.querySelectorAll('[data-tc-ci][data-tc-ci-key="' + key + '"]');
    Array.prototype.forEach.call(els, function (el) {
      if (quantity === 0) {
        el.classList.add('is-busy');
        return;
      }
      var qtyEl = el.querySelector('[data-tc-ci-qty]');
      if (qtyEl) { qtyEl.textContent = quantity; }
      var minus = el.querySelector('[data-tc-ci-minus]');
      if (minus) { minus.disabled = quantity <= 1; }
    });

    if (tcCart.timers[key]) { window.clearTimeout(tcCart.timers[key]); }
    var delay = quantity === 0 ? 0 : 350;
    tcCart.timers[key] = window.setTimeout(function () {
      tcCart.timers[key] = null;
      cartRequestChange(key, quantity)
        .then(function (cart) {
          var capped = false;
          if (quantity > 0) {
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].key === key && cart.items[i].quantity < quantity) { capped = true; break; }
            }
          }
          applyCartState(cart);
          if (capped) {
            cartItemError(key, 'Estoque máximo disponível para este item.');
          }
        })
        .catch(function (err) {
          var message = (err && err.cartError && err.message) || 'Não foi possível atualizar a sacola. Tente novamente.';
          if (tcCart.state) {
            applyCartState(tcCart.state);
            cartItemError(key, message);
          } else {
            fetchCartState()
              .then(function (cart) {
                applyCartState(cart);
                cartItemError(key, message);
              })
              .catch(function () { cartItemError(key, message); });
          }
        });
    }, delay);
  }

  /* ---- Drawer: abrir/fechar (overlay, ×, Esc, focus trap, aria) ---- */
  function cartDrawerKeydown(event) {
    var root = cartDrawerEl();
    if (!root || !root.classList.contains('is-open')) { return; }
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeCartDrawer();
      return;
    }
    if (event.key === 'Tab') { trapTab(root, event); }
  }

  function openCartDrawer(mode, addedKey, trigger) {
    var root = cartDrawerEl();
    if (!root) { return false; }
    tcCart.mode = mode === 'added' ? 'added' : 'cart';
    tcCart.addedKey = addedKey || null;
    tcCart.lastFocus = trigger || document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tc-scroll-lock');
    if (!tcCart.keydownBound) {
      tcCart.keydownBound = cartDrawerKeydown;
      document.addEventListener('keydown', tcCart.keydownBound);
    }
    var closeBtn = root.querySelector('button[data-tc-cartd-close]');
    if (closeBtn) { closeBtn.focus(); }
    /* renderiza o estado conhecido já e revalida via /cart.js */
    renderCartDrawer();
    fetchCartState()
      .then(applyCartState)
      .catch(function () { /* SSR/último estado seguem valendo */ });
    return true;
  }

  function closeCartDrawer() {
    var root = cartDrawerEl();
    if (!root || !root.classList.contains('is-open')) { return; }
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tc-scroll-lock');
    if (tcCart.keydownBound) {
      document.removeEventListener('keydown', tcCart.keydownBound);
      tcCart.keydownBound = null;
    }
    tcCart.mode = 'cart';
    tcCart.addedKey = null;
    if (tcCart.lastFocus && typeof tcCart.lastFocus.focus === 'function' && document.body.contains(tcCart.lastFocus) && tcCart.lastFocus.getClientRects().length > 0) {
      tcCart.lastFocus.focus();
    }
    tcCart.lastFocus = null;
  }

  /* Pós-add: drawer novo no estado ADICIONADO! quando existir no DOM;
     fallback: mini-cart antigo (#nt_cart_canvas). */
  function openAfterAdd(data) {
    if (cartDrawerEl()) {
      return openCartDrawer('added', data && data.key ? data.key : null);
    }
    return openThemeMiniCart();
  }

  /* Sacola do header ([data-tc-cart-open]): com o drawer novo no DOM,
     remove a classe .push_side para desativar o handler antigo do canvas;
     sem o drawer, mantém o comportamento antigo intacto (fallback). */
  function cartBindTriggers() {
    if (!cartDrawerEl()) { return; }
    var triggers = document.querySelectorAll('[data-tc-cart-open]');
    Array.prototype.forEach.call(triggers, function (trigger) {
      trigger.classList.remove('push_side');
    });
  }

  /* Upsell da página /cart: busca esta mesma section via endpoint de
     recommendations (section_id) e injeta o carrossel SSR (tc-product-card
     com quick view). */
  function initCartPageUpsell() {
    var wrap = document.querySelector('[data-tc-cartp-upsell]');
    if (!wrap || wrap.dataset.tcUpsellReady) { return; }
    var url = wrap.getAttribute('data-tc-upsell-url');
    if (!url) { return; }
    wrap.dataset.tcUpsellReady = '1';
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) { throw new Error('HTTP ' + res.status); }
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-tc-cartp-upsell-inner]');
        if (!inner || !inner.querySelector('.tc-card')) { return; }
        wrap.appendChild(document.importNode(inner, true));
        wrap.hidden = false;
        initCarousels(wrap);
      })
      .catch(function () { /* upsell é enhancement */ });
  }

  function initCartUI() {
    if (tcCart.uiBound) { return; }
    tcCart.uiBound = true;

    cartBindTriggers();
    initCartPageUpsell();

    document.addEventListener('click', function (event) {
      var t = event.target.closest('[data-tc-cart-open]');
      if (t) {
        if (cartDrawerEl()) {
          event.preventDefault();
          openCartDrawer('cart', null, t);
        }
        return;
      }
      t = event.target.closest('[data-tc-cartd-close]');
      if (t) {
        event.preventDefault();
        closeCartDrawer();
        return;
      }
      t = event.target.closest('[data-tc-ci-minus], [data-tc-ci-plus], [data-tc-ci-remove]');
      if (t) {
        event.preventDefault();
        var itemEl = t.closest('[data-tc-ci]');
        if (!itemEl) { return; }
        var key = itemEl.getAttribute('data-tc-ci-key');
        if (!key) { return; }
        if (t.hasAttribute('data-tc-ci-remove')) {
          cartChangeQty(key, 0);
          return;
        }
        var qtyEl = itemEl.querySelector('[data-tc-ci-qty]');
        var current = parseInt(qtyEl && qtyEl.textContent, 10) || 1;
        var next = t.hasAttribute('data-tc-ci-plus') ? current + 1 : Math.max(1, current - 1);
        if (next === current) { return; }
        cartChangeQty(key, next);
      }
    });

    /* Nota do pedido (página): salva sem exigir submit — o form 'cart'
       continua sendo o fallback sem JS. */
    document.addEventListener('change', function (event) {
      var note = event.target.closest('[data-tc-cartp-note]');
      if (!note) { return; }
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ note: note.value })
      }).catch(function () { /* fallback: submit do form */ });
    });

    /* Estado inicial: badge/barras/rollback prontos (GET /cart.js) */
    if (cartDrawerEl() || cartPageEl()) {
      fetchCartState()
        .then(applyCartState)
        .catch(function () { /* SSR já cobre o primeiro paint */ });
    }
  }

  /* ==================================================================
     PDP TC Zenith — [data-tc-pmain] (plano-produto-zenith.md)
     Galeria mobile (scroll-snap + setas circulares + contador) + zoom
     viewer fullscreen, resolução combinatória de variantes com estado
     ÚNICO buy box ↔ sticky ATC bar (pills do sticky são espelhos das do
     buy box), escassez por variante (inventory no JSON embutido pela
     section), guia de tamanhos (modal), sticky bar via
     IntersectionObserver no CTA principal, vistos recentemente
     (localStorage "tc_recently") e related via fetch da própria section
     (routes.product_recommendations_url + section_id).
     ================================================================== */
  var TC_SVG_EYE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>';

  function tcScrollBehavior() {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return 'auto'; }
    } catch (err) { /* usa smooth */ }
    return 'smooth';
  }

  /* Contador "1/N" de uma track scroll-snap */
  function pdpBindCounter(track, counter, slideSelector) {
    var set = function () {
      var slides = track.querySelectorAll(slideSelector);
      if (!counter || !slides.length) { return; }
      var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) + 1;
      index = Math.min(Math.max(index, 1), slides.length);
      counter.textContent = index + '/' + slides.length;
    };
    var pending = null;
    track.addEventListener('scroll', function () {
      if (pending) { window.cancelAnimationFrame(pending); }
      pending = window.requestAnimationFrame(set);
    }, { passive: true });
    set();
  }

  /* Mesmo critério combinatório do quick view: valores já escolhidos nas
     outras opções restringem a disponibilidade desta. */
  function pdpValueHasAvailability(variants, optionIndex, value, values) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.available) { continue; }
      if (v.options[optionIndex] !== value) { continue; }
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (j === optionIndex || values[j] === null || values[j] === undefined) { continue; }
        if (v.options[j] !== values[j]) { ok = false; break; }
      }
      if (ok) { return true; }
    }
    return false;
  }

  function pdpFlashLabel(btn, text) {
    if (!btn) { return; }
    var original = btn.dataset.tcLabel || btn.textContent;
    btn.dataset.tcLabel = original;
    btn.textContent = text;
    window.setTimeout(function () { btn.textContent = btn.dataset.tcLabel || original; }, 2000);
  }

  /* Grava o produto atual em localStorage["tc_recently"] (máx. 8) */
  function pdpRecordRecently(root) {
    var el = root.querySelector('[data-tc-recently-product]');
    if (!el) { return; }
    try {
      var p = JSON.parse(el.textContent);
      if (!p || !p.handle) { return; }
      p.t = Date.now();
      var list = [];
      try { list = JSON.parse(window.localStorage.getItem('tc_recently') || '[]'); } catch (err) { list = []; }
      if (!Array.isArray(list)) { list = []; }
      list = list.filter(function (x) { return x && x.handle && x.handle !== p.handle; });
      list.unshift(p);
      if (list.length > 8) { list = list.slice(0, 8); }
      window.localStorage.setItem('tc_recently', JSON.stringify(list));
    } catch (err) { /* enhancement: sem localStorage, segue sem gravar */ }
  }

  function initPdp() {
    var root = document.querySelector('[data-tc-pmain]');
    if (!root || root.dataset.tcPdpReady) { return; }
    root.dataset.tcPdpReady = '1';

    pdpRecordRecently(root);

    var productUrl = root.getAttribute('data-tc-product-url') || window.location.pathname;
    var productId = root.getAttribute('data-tc-product-id') || null;
    var productAvailable = root.getAttribute('data-tc-available') === 'true';
    var labels = {
      soldout: root.getAttribute('data-tc-label-soldout') || 'ESGOTADO',
      choose: root.getAttribute('data-tc-label-choose') || 'ESCOLHA O TAMANHO'
    };

    /* ---- Galeria mobile ---- */
    var galleryTrack = root.querySelector('[data-tc-pgallery-track]');
    var galleryCounter = root.querySelector('[data-tc-pgallery-counter]');
    if (galleryTrack && galleryCounter) {
      pdpBindCounter(galleryTrack, galleryCounter, '[data-tc-pgallery-slide]');
    }

    /* ---- Zoom viewer fullscreen ---- */
    var zoom = root.querySelector('[data-tc-pzoomv]');
    var zoomTrack = zoom ? zoom.querySelector('[data-tc-pzoomv-track]') : null;
    var zoomCounter = zoom ? zoom.querySelector('[data-tc-pzoomv-counter]') : null;
    var zoomLastFocus = null;
    var zoomKeydownBound = null;
    if (zoomTrack && zoomCounter) {
      pdpBindCounter(zoomTrack, zoomCounter, '[data-tc-pzoomv-slide]');
    }

    function zoomKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        zoomClose();
        return;
      }
      if (event.key === 'Tab') {
        trapTab(zoom, event);
        return;
      }
      if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight') && zoomTrack) {
        event.preventDefault();
        zoomTrack.scrollBy({ left: event.key === 'ArrowLeft' ? -zoomTrack.clientWidth : zoomTrack.clientWidth, behavior: tcScrollBehavior() });
      }
    }

    function zoomOpen(index, trigger) {
      if (!zoom) { return; }
      zoomLastFocus = trigger || document.activeElement;
      zoom.classList.add('is-open');
      zoom.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tc-scroll-lock');
      zoomKeydownBound = zoomKeydown;
      document.addEventListener('keydown', zoomKeydownBound);
      if (zoomTrack) {
        window.requestAnimationFrame(function () {
          zoomTrack.scrollTo({ left: index * zoomTrack.clientWidth });
        });
      }
      var closeBtn = zoom.querySelector('[data-tc-pzoomv-close]');
      if (closeBtn) { closeBtn.focus(); }
    }

    function zoomClose() {
      if (!zoom || !zoom.classList.contains('is-open')) { return; }
      zoom.classList.remove('is-open');
      zoom.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tc-scroll-lock');
      if (zoomKeydownBound) {
        document.removeEventListener('keydown', zoomKeydownBound);
        zoomKeydownBound = null;
      }
      if (zoomLastFocus && typeof zoomLastFocus.focus === 'function' && document.body.contains(zoomLastFocus)) {
        zoomLastFocus.focus();
      }
      zoomLastFocus = null;
    }

    /* ---- Guia de tamanhos (modal hairline) ---- */
    var guide = root.querySelector('[data-tc-psizeg]');
    var guideLastFocus = null;
    var guideKeydownBound = null;

    function guideKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        guideClose();
        return;
      }
      if (event.key === 'Tab') { trapTab(guide, event); }
    }

    function guideOpen(trigger) {
      if (!guide) { return; }
      guideLastFocus = trigger || document.activeElement;
      guide.classList.add('is-open');
      guide.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tc-scroll-lock');
      guideKeydownBound = guideKeydown;
      document.addEventListener('keydown', guideKeydownBound);
      var closeBtn = guide.querySelector('button[data-tc-psizeg-close]');
      if (closeBtn) { closeBtn.focus(); }
    }

    function guideClose() {
      if (!guide || !guide.classList.contains('is-open')) { return; }
      guide.classList.remove('is-open');
      guide.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tc-scroll-lock');
      if (guideKeydownBound) {
        document.removeEventListener('keydown', guideKeydownBound);
        guideKeydownBound = null;
      }
      if (guideLastFocus && typeof guideLastFocus.focus === 'function' && document.body.contains(guideLastFocus)) {
        guideLastFocus.focus();
      }
      guideLastFocus = null;
    }

    /* ---- Variantes: um estado só (buy box ↔ sticky bar) ---- */
    var dataEl = root.querySelector('[data-tc-pvariants]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (err) { variants = []; }

    var optionRows = root.querySelectorAll('[data-tc-pbuy] [data-tc-option-index]');
    var form = root.querySelector('[data-tc-pbuy] form[action*="/cart/add"]');
    var select = root.querySelector('[data-tc-pselect]');
    var mainBtn = root.querySelector('[data-tc-patc]');
    var bar = root.querySelector('[data-tc-atcbar]');
    var barBtn = root.querySelector('[data-tc-atcbar-add]');
    var errorEl = root.querySelector('[data-tc-perror]');
    var priceEls = root.querySelectorAll('[data-tc-pprice]');
    var compareEls = root.querySelectorAll('[data-tc-pcompare]');
    var parcelasEls = root.querySelectorAll('[data-tc-pparcelas]');
    var scarcityEl = root.querySelector('[data-tc-pscarcity]');
    var interacted = false;

    function selectedValues() {
      var values = [];
      Array.prototype.forEach.call(optionRows, function (row) {
        var idx = parseInt(row.dataset.tcOptionIndex, 10);
        var sel = row.querySelector('[data-tc-value].is-selected');
        values[idx] = sel ? sel.getAttribute('data-tc-value') : null;
      });
      return values;
    }

    /* Estrito: só resolve com TODAS as opções escolhidas */
    function currentVariant() {
      if (!variants.length) { return null; }
      if (!optionRows.length) { return variants[0]; }
      var values = selectedValues();
      for (var j = 0; j < values.length; j++) {
        if (values[j] === null || values[j] === undefined) { return null; }
      }
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var k = 0; k < values.length; k++) {
          if (variants[i].options[k] !== values[k]) { ok = false; break; }
        }
        if (ok) { return variants[i]; }
      }
      return null;
    }

    function refresh() {
      var values = selectedValues();

      Array.prototype.forEach.call(optionRows, function (row) {
        var idx = parseInt(row.dataset.tcOptionIndex, 10);
        Array.prototype.forEach.call(row.querySelectorAll('[data-tc-value]'), function (btn) {
          var has = pdpValueHasAvailability(variants, idx, btn.getAttribute('data-tc-value'), values);
          btn.classList.toggle('is-unavailable', !has);
          btn.setAttribute('aria-disabled', has ? 'false' : 'true');
        });
        var current = row.querySelector('[data-tc-opt-current]');
        if (current) { current.textContent = values[idx] || '—'; }
      });

      /* espelha seleção/disponibilidade nas pills do sticky */
      Array.prototype.forEach.call(root.querySelectorAll('[data-tc-mirror-index]'), function (mirror) {
        var idx = parseInt(mirror.dataset.tcMirrorIndex, 10);
        var srcRow = root.querySelector('[data-tc-pbuy] [data-tc-option-index="' + idx + '"]');
        if (!srcRow) { return; }
        var byValue = {};
        Array.prototype.forEach.call(srcRow.querySelectorAll('[data-tc-value]'), function (btn) {
          byValue[btn.getAttribute('data-tc-value')] = btn;
        });
        Array.prototype.forEach.call(mirror.querySelectorAll('[data-tc-value]'), function (btn) {
          var src = byValue[btn.getAttribute('data-tc-value')];
          if (!src) { return; }
          var isSel = src.classList.contains('is-selected');
          btn.classList.toggle('is-selected', isSel);
          btn.classList.toggle('is-unavailable', src.classList.contains('is-unavailable'));
          btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
          btn.setAttribute('aria-disabled', src.getAttribute('aria-disabled') || 'false');
        });
      });

      var variant = currentVariant();

      /* escassez: só estoque REAL rastreado (managed) — nunca inventa */
      if (scarcityEl) {
        var show = false;
        if (variant && variant.managed && variant.available && variant.qty > 0) {
          var threshold = parseInt(scarcityEl.getAttribute('data-tc-scarcity-threshold'), 10) || 5;
          if (variant.qty <= threshold) {
            var tpl = scarcityEl.getAttribute('data-tc-scarcity-template') || 'Restam só [n]';
            scarcityEl.textContent = tpl.replace('[n]', variant.qty);
            show = true;
          }
        }
        scarcityEl.hidden = !show;
      }

      if (variant) {
        Array.prototype.forEach.call(priceEls, function (el) { el.textContent = formatMoney(variant.price); });
        Array.prototype.forEach.call(compareEls, function (el) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            el.textContent = formatMoney(variant.compare_at_price);
            el.hidden = false;
          } else {
            el.hidden = true;
          }
        });
        Array.prototype.forEach.call(parcelasEls, function (el) {
          var n = parseInt(el.getAttribute('data-tc-parcelas-n'), 10) || 6;
          el.innerHTML = 'ou <span class="tc-parcela-hl">' + n + 'x de ' + formatMoney(Math.round(variant.price / n)) + '</span> sem juros';
        });
        if (select) { select.value = String(variant.id); }
        /* ?variant= sem reload — só depois de interação (ou se já veio na URL) */
        if (interacted || window.location.search.indexOf('variant=') > -1) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          } catch (err) { /* enhancement */ }
        }
      }

      if (productAvailable) {
        var soldout = !!(variant && !variant.available);
        if (mainBtn) {
          mainBtn.disabled = soldout;
          mainBtn.textContent = soldout ? labels.soldout : (mainBtn.dataset.tcLabel || mainBtn.textContent);
        }
        if (barBtn) {
          barBtn.disabled = soldout;
          barBtn.textContent = soldout ? labels.soldout : (barBtn.dataset.tcLabel || barBtn.textContent);
        }
      }
    }

    function selectValue(idx, value) {
      var row = root.querySelector('[data-tc-pbuy] [data-tc-option-index="' + idx + '"]');
      if (!row) { return; }
      interacted = true;
      Array.prototype.forEach.call(row.querySelectorAll('[data-tc-value]'), function (btn) {
        var sel = btn.getAttribute('data-tc-value') === value;
        btn.classList.toggle('is-selected', sel);
        btn.setAttribute('aria-pressed', sel ? 'true' : 'false');
      });
      if (errorEl) { errorEl.hidden = true; }
      refresh();
    }

    function pdpSubmit(trigger) {
      var variant = currentVariant();
      if (!variant) {
        var fromBar = !!(trigger && trigger.closest && trigger.closest('[data-tc-atcbar]'));
        var isMobile = true;
        try { isMobile = !window.matchMedia('(min-width: 990px)').matches; } catch (err) { isMobile = true; }
        if (fromBar && isMobile) {
          /* §5: sticky mobile sem tamanho → painel de seleção (quick view do próprio produto) */
          qvOpen(productUrl, trigger);
          return;
        }
        if (errorEl) {
          errorEl.textContent = labels.choose;
          errorEl.hidden = false;
        }
        if (fromBar) { pdpFlashLabel(barBtn, labels.choose); }
        var scopeSel = fromBar
          ? '[data-tc-atcbar] [data-tc-mirror-index] [data-tc-value]:not(.is-unavailable)'
          : '[data-tc-pbuy] [data-tc-option-index] [data-tc-value]:not(.is-unavailable)';
        var firstPill = root.querySelector(scopeSel) || root.querySelector('[data-tc-pbuy] [data-tc-option-index] [data-tc-value]');
        if (firstPill) { firstPill.focus(); }
        return;
      }
      if (!variant.available) { return; }
      var btn = trigger || mainBtn;
      if (btn && (btn.classList.contains('is-loading') || btn.getAttribute('aria-disabled') === 'true')) { return; }
      if (errorEl) { errorEl.hidden = true; }
      if (btn) {
        btn.dataset.tcLabel = btn.dataset.tcLabel || btn.textContent;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-disabled', 'true');
      }
      addToCart(variant.id, 1)
        .then(function (data) {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-disabled');
          }
          updateCartBadge(productId);
          /* drawer novo no estado ADICIONADO! (fase carrinho); fallback: mini-cart antigo */
          openAfterAdd(data);
        })
        .catch(function (err) {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-disabled');
          }
          if (errorEl) {
            errorEl.textContent = (err && err.cartError && err.message) || 'Não foi possível adicionar à sacola. Tente novamente.';
            errorEl.hidden = false;
          }
        });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        pdpSubmit(mainBtn);
      });
    }
    if (barBtn) {
      barBtn.addEventListener('click', function (event) {
        event.preventDefault();
        pdpSubmit(barBtn);
      });
    }

    /* ---- Sticky ATC bar: IntersectionObserver no CTA principal ---- */
    if (bar && mainBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.documentElement.classList.toggle('tc-atcbar-open', show);
      });
      io.observe(mainBtn);
    }

    /* ---- Cliques delegados da PDP ---- */
    root.addEventListener('click', function (event) {
      var opt = event.target.closest('[data-tc-option-index] [data-tc-value], [data-tc-mirror-index] [data-tc-value]');
      if (opt && root.contains(opt)) {
        event.preventDefault();
        if (opt.classList.contains('is-unavailable')) { return; }
        var wrap = opt.closest('[data-tc-option-index], [data-tc-mirror-index]');
        var idx = parseInt(wrap.getAttribute('data-tc-option-index') || wrap.getAttribute('data-tc-mirror-index'), 10);
        selectValue(idx, opt.getAttribute('data-tc-value'));
        return;
      }

      var t = event.target.closest('[data-tc-pgallery-prev], [data-tc-pgallery-next]');
      if (t && galleryTrack) {
        event.preventDefault();
        galleryTrack.scrollBy({ left: t.hasAttribute('data-tc-pgallery-prev') ? -galleryTrack.clientWidth : galleryTrack.clientWidth, behavior: tcScrollBehavior() });
        return;
      }

      t = event.target.closest('[data-tc-pzoom-open]');
      if (t) {
        event.preventDefault();
        var index = parseInt(t.getAttribute('data-tc-zoom-index'), 10);
        if (isNaN(index)) {
          index = galleryTrack ? Math.round(galleryTrack.scrollLeft / Math.max(galleryTrack.clientWidth, 1)) : 0;
        }
        zoomOpen(index, t);
        return;
      }

      t = event.target.closest('[data-tc-pzoomv-prev], [data-tc-pzoomv-next]');
      if (t && zoomTrack) {
        event.preventDefault();
        zoomTrack.scrollBy({ left: t.hasAttribute('data-tc-pzoomv-prev') ? -zoomTrack.clientWidth : zoomTrack.clientWidth, behavior: tcScrollBehavior() });
        return;
      }

      if (event.target.closest('[data-tc-pzoomv-close]')) {
        event.preventDefault();
        zoomClose();
        return;
      }

      t = event.target.closest('[data-tc-psizeg-open]');
      if (t) {
        event.preventDefault();
        guideOpen(t);
        return;
      }

      if (event.target.closest('[data-tc-psizeg-close]')) {
        event.preventDefault();
        guideClose();
      }
    });

    if (variants.length) { refresh(); }
  }

  /* ---- P8 Vistos recentemente: mini-cards client-side ---- */
  function buildRecentlyCard(p) {
    var item = document.createElement('div');
    item.className = 'tc-rv__item';

    var card = document.createElement('div');
    card.className = 'tc-rv__card';

    var media = document.createElement('div');
    media.className = 'tc-rv__media';

    var mediaLink = document.createElement('a');
    mediaLink.className = 'tc-rv__medialink';
    mediaLink.href = p.url;
    mediaLink.tabIndex = -1;
    mediaLink.setAttribute('aria-hidden', 'true');
    if (p.image) {
      var img = document.createElement('img');
      img.src = p.image;
      img.width = 240;
      img.height = 240;
      img.loading = 'lazy';
      img.alt = '';
      mediaLink.appendChild(img);
    } else {
      var ph = document.createElement('span');
      ph.className = 'tc-rv__ph';
      ph.setAttribute('aria-hidden', 'true');
      mediaLink.appendChild(ph);
    }
    media.appendChild(mediaLink);

    var eye = document.createElement('button');
    eye.type = 'button';
    eye.className = 'tc-rv__eye';
    eye.setAttribute('data-tc-qv', p.url);
    eye.setAttribute('aria-label', 'Visualização rápida: ' + p.title);
    eye.innerHTML = TC_SVG_EYE;
    media.appendChild(eye);

    /* Numeração rápida (mesmo overlay do card) quando há tamanhos gravados */
    if (p.sizes && p.sizes.length) {
      var qa = document.createElement('div');
      qa.className = 'tc-card__quickadd';
      qa.setAttribute('aria-label', 'Adicionar por tamanho');
      for (var si = 0; si < p.sizes.length; si++) {
        var s = p.sizes[si];
        var sb = document.createElement('button');
        sb.type = 'button';
        sb.className = 'tc-card__size' + (s.available ? '' : ' is-unavailable');
        sb.setAttribute('data-tc-qadd', '');
        sb.setAttribute('data-tc-variant-id', s.id);
        if (!s.available) { sb.disabled = true; sb.setAttribute('aria-disabled', 'true'); }
        sb.setAttribute('aria-label', 'Adicionar tamanho ' + s.title);
        sb.textContent = s.title;
        qa.appendChild(sb);
      }
      media.appendChild(qa);
    }

    card.appendChild(media);

    var title = document.createElement('p');
    title.className = 'tc-rv__title';
    var link = document.createElement('a');
    link.href = p.url;
    link.textContent = p.title;
    title.appendChild(link);
    card.appendChild(title);

    var price = document.createElement('p');
    price.className = 'tc-rv__price';
    var now = document.createElement('span');
    now.className = 'tc-rv__now';
    now.textContent = formatMoney(p.price);
    price.appendChild(now);
    if (p.compare_at_price && p.compare_at_price > p.price) {
      var was = document.createElement('s');
      was.className = 'tc-rv__was';
      was.textContent = formatMoney(p.compare_at_price);
      price.appendChild(was);
    }
    card.appendChild(price);

    item.appendChild(card);
    return item;
  }

  function initRecentlyViewed(scope) {
    var sections = (scope || document).querySelectorAll('[data-tc-recently]');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.tcRvReady) { return; }
      section.dataset.tcRvReady = '1';
      var track = section.querySelector('[data-tc-rv-track]');
      if (!track) { return; }
      var exclude = section.getAttribute('data-tc-exclude');
      var list = [];
      try { list = JSON.parse(window.localStorage.getItem('tc_recently') || '[]'); } catch (err) { list = []; }
      if (!Array.isArray(list)) { list = []; }
      list = list.filter(function (p) {
        return p && p.handle && p.title && p.url && typeof p.price === 'number' && p.handle !== exclude;
      });
      if (!list.length) { return; }
      track.innerHTML = '';
      for (var i = 0; i < list.length && i < 8; i++) {
        track.appendChild(buildRecentlyCard(list[i]));
      }
      section.hidden = false;
      initCarousels(section);
    });
  }

  /* ---- P7 Related: fetch da própria section (recommendations) ---- */
  function initRelatedSections(scope) {
    var wraps = (scope || document).querySelectorAll('[data-tc-related]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.dataset.tcRelatedReady) { return; }
      var url = wrap.getAttribute('data-tc-related-url');
      if (!url) { return; }
      wrap.dataset.tcRelatedReady = '1';
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) { throw new Error('HTTP ' + res.status); }
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-tc-related-inner]');
          if (!inner || !inner.querySelector('.tc-card')) { return; }
          wrap.appendChild(document.importNode(inner, true));
          wrap.hidden = false;
          initCarousels(wrap);
        })
        .catch(function () { /* related é enhancement */ });
    });
  }

  /* ------------------------------------------------------------------
     Coleção TC Zenith — C3/C4/C6 (plano-colecao-zenith.md)
     [data-tc-cgrid]: toggle de densidade do grid desktop 4⇄2 col. sem
     reload (localStorage "tc_grid_view"), sort por navegação (form GET
     preserva filtros via hidden inputs) e drawer de filtros
     [data-tc-cfd] — overlay, ×, Esc, focus trap, mesmo padrão dos
     outros drawers tc. Filtros aplicam por navegação normal (sem AJAX).
     ------------------------------------------------------------------ */
  var tcCfd = { lastFocus: null, keydownBound: null, clicksBound: false };

  function cfdEl() {
    return document.querySelector('[data-tc-cfd]');
  }

  function cfdKeydown(event) {
    var root = cfdEl();
    if (!root || !root.classList.contains('is-open')) { return; }
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      closeFilterDrawer();
      return;
    }
    if (event.key === 'Tab') { trapTab(root, event); }
  }

  function openFilterDrawer(trigger) {
    var root = cfdEl();
    if (!root) { return; }
    tcCfd.lastFocus = trigger || document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tc-scroll-lock');
    if (!tcCfd.keydownBound) {
      tcCfd.keydownBound = cfdKeydown;
      document.addEventListener('keydown', tcCfd.keydownBound);
    }
    var closeBtn = root.querySelector('button[data-tc-cfd-close]');
    if (closeBtn) { closeBtn.focus(); }
  }

  function closeFilterDrawer() {
    var root = cfdEl();
    if (!root || !root.classList.contains('is-open')) { return; }
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tc-scroll-lock');
    if (tcCfd.keydownBound) {
      document.removeEventListener('keydown', tcCfd.keydownBound);
      tcCfd.keydownBound = null;
    }
    if (tcCfd.lastFocus && typeof tcCfd.lastFocus.focus === 'function' && document.body.contains(tcCfd.lastFocus) && tcCfd.lastFocus.getClientRects().length > 0) {
      tcCfd.lastFocus.focus();
    }
    tcCfd.lastFocus = null;
  }

  function initCollection(scope) {
    var sections = (scope || document).querySelectorAll('[data-tc-cgrid]');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.tcCgridReady) { return; }
      section.dataset.tcCgridReady = '1';

      /* ---- densidade 4⇄2 (só desktop; persiste em localStorage) ---- */
      var grid = section.querySelector('[data-tc-cgrid-grid]');
      var viewBtns = section.querySelectorAll('[data-tc-view]');

      function applyView(view) {
        if (grid) { grid.classList.toggle('tc-cgrid__grid--big', view === '2'); }
        Array.prototype.forEach.call(viewBtns, function (btn) {
          var active = btn.getAttribute('data-tc-view') === view;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      var saved = '4';
      try { saved = window.localStorage.getItem('tc_grid_view') || '4'; } catch (err) { saved = '4'; }
      if (saved !== '2') { saved = '4'; }
      applyView(saved);

      Array.prototype.forEach.call(viewBtns, function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          var view = btn.getAttribute('data-tc-view') === '2' ? '2' : '4';
          try { window.localStorage.setItem('tc_grid_view', view); } catch (err) { /* enhancement */ }
          applyView(view);
        });
      });

      /* ---- sort: navega via GET preservando filtros (hidden inputs) ---- */
      var sortSelect = section.querySelector('[data-tc-sort-select]');
      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          var form = sortSelect.closest('form');
          if (form) { form.submit(); }
        });
      }
    });

    /* cliques delegados do drawer de filtros — bind único */
    if (!tcCfd.clicksBound) {
      tcCfd.clicksBound = true;
      document.addEventListener('click', function (event) {
        var t = event.target.closest('[data-tc-cfd-open]');
        if (t) {
          event.preventDefault();
          openFilterDrawer(t);
          return;
        }
        t = event.target.closest('[data-tc-cfd-close]');
        if (t) {
          event.preventDefault();
          closeFilterDrawer();
        }
      });
    }
  }

  /* ------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------ */
  function init() {
    initTabs(document);
    initCarousels(document);
    initShowcase(document);
    initCardAdd();
    initQuickView();
    initHeaderMega(document);
    initFooterCols(document);
    initGlobalNav();
    initCartUI();
    initPdp();
    initRecentlyViewed(document);
    initRelatedSections(document);
    initCollection(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Editor de temas: re-inicializa quando uma seção é (re)carregada */
  document.addEventListener('shopify:section:load', function (event) {
    initTabs(event.target);
    initCarousels(event.target);
    initShowcase(event.target);
    initHeaderMega(event.target);
    initFooterCols(event.target);
    cartBindTriggers();
    initCartPageUpsell();
    initPdp();
    initRecentlyViewed(document);
    initRelatedSections(document);
    initCollection(event.target);
    if (tcCart.state) { applyCartState(tcCart.state); }
  });

  /* API mínima para debug/extensões futuras */
  window.tcZenith = {
    formatMoney: formatMoney,
    updateCartBadge: updateCartBadge,
    openThemeMiniCart: openThemeMiniCart,
    openQuickView: qvOpen,
    closeQuickView: qvClose,
    openMenuDrawer: openDrawer,
    closeMenuDrawer: closeDrawer,
    openSearchOverlay: openSearch,
    closeSearchOverlay: closeSearch,
    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,
    openFilterDrawer: openFilterDrawer,
    closeFilterDrawer: closeFilterDrawer,
    refreshCart: function () {
      return fetchCartState().then(applyCartState);
    }
  };
})();
